import type { GetAssetsPlayersImagesResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getAssetsPlayersImages = async (lang?: string) => {
    return await getGenericEndpoint<GetAssetsPlayersImagesResponse>('assets/background-images', lang, false);
};
